import { render, staticRenderFns } from "./Prediction.vue?vue&type=template&id=15c83f34&"
import script from "./Prediction.vue?vue&type=script&lang=js&"
export * from "./Prediction.vue?vue&type=script&lang=js&"
import style0 from "./Prediction.vue?vue&type=style&index=0&id=15c83f34&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports